enum Type {
  NUMBER_OF_CHARACTERS = 'NUMBER_OF_CHARACTERS',
  COLUMN = 'COLUMN',
  INPUT_VALUE = 'INPUT_VALUE',
  STANDARD_VALUE = 'STANDARD_VALUE',
}

/**
 * Sentinel stored in `right_value` for a STANDARD_VALUE condition and in
 * `value` for a TIME_DIFFERENCE constant. The backend resolves it to the
 * current date at run time.
 */
export const TODAY = '__TODAY__'

export default Type
